import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.page.html',
  styleUrls: ['./error-page.page.scss'],
  standalone: false,
})
export class ErrorPagePage {
  public desiredUrl = '';

  constructor(private route: Router) {}

  ngOnInit(): void {
    this.desiredUrl = this.route.url;
  }
}
